import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ScrollToTop from "./views/components/ScrollToTop";

// MediData
import Home from "./views/Home";
import Confirmation from "./views/Step10_Confirmation";

// Fallback page
import PageNotFound from "./views/components/PageNotFound";

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Navigate to="/de/home" replace />} />
                <Route path="*" element={<PageNotFound />} />

                <Route path="/:language/home" element={<Home />} />
                <Route path="/:language/confirmation/:orderId" element={<Confirmation />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;